// Mantive esse export para manter compatibilidade com as sagas que lançam efeitos sob essas actions
import mapElementSlice from './mapElementSlice';
export const mapElementActions = mapElementSlice.actions;
